/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService
 */
import * as References from './UserProgressWriterChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService#startProgress
 */
export const START_PROGRESS_MUTATION_FIELD_NAME = 'com_hubspot_academy_user_progress_rpc_UserProgressWriterChirpService_startProgress';
export const START_PROGRESS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_PROGRESS_MUTATION_FIELD_NAME,
  args: ['contentId', 'contentType', 'trackId', 'playlistId', 'language', 'timestamp'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.startProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.user.progress.rpc.UserProgressWriterChirpService#markContentCompleted
 */
export const MARK_CONTENT_COMPLETED_MUTATION_FIELD_NAME = 'com_hubspot_academy_user_progress_rpc_UserProgressWriterChirpService_markContentCompleted';
export const MARK_CONTENT_COMPLETED_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MARK_CONTENT_COMPLETED_MUTATION_FIELD_NAME,
  args: ['contentId', 'trackId', 'lessonId', 'playlistId', 'progressType', 'language', 'source', 'createdAt'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.markContentCompletedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});